export const SHIFT_STATUS = Object.freeze({
  scheduled: {
    title: 'Scheduled',
    text: 'Shift has been scheduled.',
    color: '#6b7280'
  },
  started: {
    title: 'Started',
    text: 'Shift is currently in progress.',
    color: '#3b82f6'
  },
  missed: {
    title: 'Missed',
    text: 'Shift has been missed.',
    color: '#ef4444'
  },
  cancelled: {
    title: 'Cancelled',
    text: 'Shift has been cancelled.',
    color: '#ef4444'
  },
  completed: {
    title: 'Completed',
    color: '#10b981',
    text: 'Shift has been competed.'
  },
  deleted: {
    title: 'Deleted',
    text: 'Shift has been deleted.',
    color: '#ef4444'
  }
})

export const SHIFT_PAYMENT_REQUEST_STATUS = Object.freeze({
  not_paid: {
    title: 'Ready To Pay',
    color: '#10b981',
    text: 'Shift has not been paid.'
  },
  paid: {
    title: 'Paid',
    color: '#6b7280',
    text: 'Shift has been paid.'
  },
  in_progress: {
    title: 'Payment In Progress',
    color: '#3b82f6',
    text: 'Payment processing is in progress.'
  },
  partially_paid: {
    title: 'Partially Paid',
    color: '#6b7280',
    text: 'Shift has been partially paid.'
  },
  draft: {
    title: 'Draft',
    color: '#21E29D',
    text: 'Payment is in draft status.'
  },
  cancelled: {
    title: 'Rejected',
    color: '#f59e0b',
    text: 'Payment was rejected.'
  }
})

export const SHIFT_PAYMENT_STATUS = Object.freeze({
  paid: {
    title: 'Paid',
    color: '#6b7280'
  },
  accepted: {
    title: 'Accepted',
    color: '#3b82f6'
  },
  not_paid: {
    title: 'Not Paid',
    color: '#10b981'
  },
  cancelled: {
    title: 'Rejected',
    color: '#f59e0b'
  },
  deleted: {
    title: 'Deleted',
    color: '#ef4444'
  },
  approved: {
    title: 'Approved',
    color: '#10b981'
  },
  denied: {
    title: 'Denied',
    color: '#ef4444'
  }
})

export const SHIFT_READY_FOR_PAYMENT_STATUS = Object.freeze({
  not_ready: {
    title: 'Not Ready To Pay',
    color: '#ef4444',
    id: 0
  },
  ready: {
    title: 'Ready To Pay',
    color: '#10b981',
    id: 1
  },
  blocked: {
    title: 'Unpaid',
    color: '#ef4444'
  }
})

export const UNPAID_SHIFT_RATE_EXCLUSION_REASON = Object.freeze({
  payment_status: {
    title: 'Payment status does not allow rate updates'
  },
  rate_type: {
    title: 'Rate type does not match the selection'
  }
})

export const SHIFT_NOT_READY_FOR_PAYMENT_FLAG = Object.freeze({
  cdphMissing: {
    title: 'Missed Manual CDPH-530',
    color: '#3b82f6'
  },
  digitalCdphNotSigned: {
    title: 'Not Signed Digital CDPH-530',
    color: '#3b82f6'
  },
  digitalCdphMissing: {
    title: 'Missed Digital CDPH-530',
    color: '#3b82f6'
  },
  notSigned: {
    title: 'Not Signed',
    color: '#3b82f6'
  },
  hasAuth: {
    title: 'Violations',
    color: '#3b82f6'
  }
})

export const AUTH_STATUSES = Object.freeze({
  associate_not_recognized_authorization: {
    title: 'Associate Not Recognized',
    approvedTitle: 'Associate Recognized',
    type: 'disciplinary'
  },
  no_actual_time_authorization: {
    title: 'Missed Tracked Time',
    approvedTitle: 'Approved Tracked Time',
    color: '#f59e0b',
    type: 'disciplinary'
  },
  early_start_authorization: {
    title: 'Early Start',
    approvedTitle: 'Approved Early Start',
    color: '#3498db',
    type: 'payroll'
  },
  late_start_authorization: {
    title: 'Late Start',
    approvedTitle: 'Approved Late Start',
    color: '#d47aff',
    type: 'disciplinary'
  },
  no_lunch_authorization: {
    title: 'No Meal Break',
    approvedTitle: 'Meal Break Not Required',
    color: '#1abc9c',
    type: 'payroll'
  },
  early_lunch_end_authorization: {
    title: 'Short Meal Break',
    approvedTitle: 'Approved Short Meal Break',
    color: '#f1c40f',
    type: 'disciplinary'
  },
  first_lunch_period_authorization: {
    title: 'First Meal Break Period',
    approvedTitle: 'Approved Meal Break Period',
    color: '#f1c40f',
    type: 'disciplinary'
  },
  no_second_lunch_authorization: {
    title: 'No 2nd Meal Break',
    approvedTitle: '2nd Meal Break Not Required',
    color: '#e67e22',
    type: 'payroll'
  },
  early_second_lunch_end_authorization: {
    title: 'Short 2nd Meal Break',
    approvedTitle: 'Approved Short 2nd Meal Break',
    color: '#e74c3c',
    type: 'disciplinary'
  },
  early_end_authorization: {
    title: 'Early End',
    approvedTitle: 'Approved Early End',
    color: '#6b7280',
    type: 'disciplinary'
  },
  late_end_authorization: {
    title: 'Late End',
    approvedTitle: 'Approved Late End',
    color: '#f59e0b',
    type: 'payroll'
  },
  overtime_authorization: {
    title: 'Unscheduled Overtime',
    color: '#7f8c8d',
    approvedTitle: 'Approved Overtime',
    type: 'payroll'
  },
  outside_work_area_authorization: {
    title: 'Outside Work Area',
    approvedTitle: 'In Work Area',
    color: '#34495e',
    type: 'disciplinary'
  },
  short_shift_authorization: {
    title: 'Short Shift',
    approvedTitle: 'Approved Short Shift',
    color: '#6b7280',
    type: 'disciplinary'
  },
  signed_actual_time_discrepancy: {
    title: 'Adjusted Track Time',
    approvedTitle: 'Track Time Correct',
    color: '#f59e0b',
    type: 'payroll'
  },
  no_rest_break_authorization: {
    title: 'No Rest Breaks',
    approvedTitle: 'Rest Breaks Not Required',
    color: '#f59e0b',
    type: 'disciplinary'
  },
  unscheduled_shift_authorization: {
    title: 'Unscheduled Shift',
    approvedTitle: 'Scheduled Shift',
    color: '#f59e0b',
    type: 'payroll'
  }
})

export const AUTH_PROCESS_STATUSES = Object.freeze({
  accepted: 'Approved',
  declined: 'Denied',
  initial: 'Unreviewed',
  unresolved: 'Unresolved'
})

export const AUTH_DISCIPLINARY_ACTIONS = Object.freeze({
  associatewriteup: 'Written Warning',
  alert: 'Notification',
  associatehold: 'Block',
  shiftpenalty: 'Suspension'
})

export const SHIFT_ORIGIN = Object.freeze({
  whereami: {
    title: 'Time Tracker',
    color: '#2563eb'
  },
  marketplace: {
    title: 'Marketplace',
    color: '#ef4444'
  },
  schedule: {
    title: 'Scheduler',
    color: '#3b82f6'
  }
})

export const PAY_CODE_READY_FOR_PAY_STATUSES = Object.freeze({
  unblocked: {
    title: 'Payable',
    color: '#10b981'
  },
  blocked: {
    title: 'Unpaid',
    color: '#ef4444'
  }
})

export const CALCULATION_STATUSES = Object.freeze({
  overtime: {
    title: 'Overtime',
    icon: 'ri-coins-fill',
    color: '#f1c40f'
  },
  double_time: {
    title: 'Double Time',
    icon: 'streamline-ultimate:money-bag-dollar-bold',
    color: '#ef4444'
  }
})

export const SHIFT_FORM_INITIAL_STATE = {
  duration: 0,
  work_start: null,
  work_end: null,
  lunch_duration: 0,
  lunch_start: null,
  lunch_end: null,
  second_lunch_duration: 0,
  second_lunch_start: null,
  second_lunch_end: null,
  actual_lunch_duration: 0,
  actual_lunch_end: null,
  actual_lunch_start: null,
  actual_second_lunch_duration: 0,
  actual_second_lunch_end: null,
  actual_second_lunch_start: null,
  actual_duration: 0,
  actual_work_end: null,
  actual_work_start: null,
  modified_by_admin: true,
  lunch_waived: false,
  emergency_on_call: false,
  set_scheduled_as_signed: false,
  rest_break_checked: true,
  hours: {
    work_hours: null,
    pay_hours: null,
    duration: null,
    actual_work_hours: null,
    actual_pay_hours: null,
    actual_duration: null,
    scheduled_work_hours: null,
    scheduled_pay_hours: null,
    scheduled_duration: null
  }
}

export const INITIAL_STATE = {
  shiftAuthorizations: [],
  shifts: {},
  shift: {},
  shiftForm: { ...SHIFT_FORM_INITIAL_STATE },
  shiftPayCodes: [],
  shiftPayments: [],
  shiftActions: []
}
